/**
 * @generated SignedSource<<42aaf4802187025c3b6c909b10c6ceeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Billing_CompanyType = "Ag" | "Einzelunternehmen" | "Ev" | "Gbr" | "Gmbh" | "GmbhCoKg" | "Kg" | "OeffentlicheEinrichtung" | "Ohg" | "PartmbH" | "Stiftung" | "Ug" | "Unknown";
export type CountryCode = "DE";
import { FragmentRefs } from "relay-runtime";
export type businessBaseDataForm_BusinessBaseDataFragment$data = {
  readonly __typename: "BusinessBaseData";
  readonly accountData: {
    readonly bic: string | null;
    readonly iban: string;
  } | null;
  readonly billingOffice: string | null;
  readonly city: string | null;
  readonly companyLegalForm: Billing_CompanyType | null;
  readonly companyName: string | null;
  readonly countryCode: CountryCode | null;
  readonly houseNumber: string | null;
  readonly invoiceEmail: string | null;
  readonly phoneNumber: string | null;
  readonly postalCode: string | null;
  readonly street: string | null;
  readonly taxData: {
    readonly taxIdentificationNumber: string;
    readonly taxNumber: string;
  } | null;
  readonly " $fragmentType": "businessBaseDataForm_BusinessBaseDataFragment";
};
export type businessBaseDataForm_BusinessBaseDataFragment$key = {
  readonly " $data"?: businessBaseDataForm_BusinessBaseDataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"businessBaseDataForm_BusinessBaseDataFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "businessBaseDataForm_BusinessBaseDataFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingOffice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyLegalForm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountData",
      "kind": "LinkedField",
      "name": "accountData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bic",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iban",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxData",
      "kind": "LinkedField",
      "name": "taxData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxIdentificationNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BusinessBaseData",
  "abstractKey": null
};

(node as any).hash = "e14484fec51a933d77cdc5a5e4346770";

export default node;
